import { useState } from 'react'
import { Modal } from '../../../../ui/Modal'
import { Button, Input } from '../../../../ui/index'
import { useMutationRefundPayment } from '../../../../../../queries/paymentQueries'

const RefundModal = ({ isOpen, onClose, card, payment, onSuccess }) => {
  const [amount, setAmount] = useState('')
  const [error, setError] = useState('')
  const [isPartial, setIsPartial] = useState(false)
  const refundPayment = useMutationRefundPayment()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

      if (isPartial) {
        const parsedAmount = parseFloat(amount)
        if (!parsedAmount || parsedAmount < 0.01) {
          setError('El monto debe ser mayor a 0.01')
          return
        }
        if (parsedAmount > payment.transactionAmount) {
          setError('El monto no puede ser mayor al monto original')
          return
        }
      }

    try {
      const refundData = isPartial ? { amount: parseFloat(amount) } : {}
      const response = await refundPayment.mutateAsync({
        cardId: card.id,
        paymentId: payment.id,
        refundData
      })

      if (onSuccess) {
        onSuccess(response)
      }
      onClose()
      setAmount('')
      setIsPartial(false)
    } catch (error) {
      setError(error.response?.data?.message || 'Error al realizar el reembolso')
    }
  }

  if (!card || !payment) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Realizar Reembolso</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className="mb-4 p-4 bg-gray-50 rounded-lg space-y-2">
          <div>
            <p className="text-sm text-gray-600">Tarjeta</p>
            <p className="font-semibold">
              {card.cardType.toUpperCase()} •••• {card.lastFourDigits}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Pago ID</p>
            <p className="font-semibold">#{payment.id}</p>
          </div>
          <div>
            <p className="text-sm text-gray-600">Monto Original</p>
            <p className="font-semibold">${payment.transactionAmount.toLocaleString('es-CL')}</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="partial"
              checked={isPartial}
              onChange={(e) => setIsPartial(e.target.checked)}
              className="w-4 h-4"
            />
            <label htmlFor="partial" className="text-sm font-medium text-gray-700">
              Reembolso parcial
            </label>
          </div>

          {isPartial && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Monto a reembolsar
              </label>
              <Input
                type="number"
                step="0.01"
                min="0.01"
                max={payment.transactionAmount}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="0.00"
                required
              />
            </div>
          )}

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              title="Cancelar"
              onClick={onClose}
              color="secondary"
              className="flex-1"
            />
            <Button
              type="submit"
              title={refundPayment.isPending ? 'Procesando...' : 'Reembolsar'}
              color="primary"
              className="flex-1"
              disabled={refundPayment.isPending}
            />
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default RefundModal
